<template>
  <div class="confirmation">
    <div class="confirmation__wrapper">
      <header class="confirmation__header">
        <h1 class="confirmation__logo"><img src="@/assets/images/logo-b-w.svg" alt="Componata"></h1>

        <p>
          <a @click="goBack()">&larr; Zurück zur Präsentauswahl</a>
        </p>
      </header>

      <div class="confirmation__content" v-if="$store.getters.getSelectedItem.data">
        <!-- <Alert
          v-if="$store.getters.getUserGroupId === 62"
          type="info"
        >
          Sofort versandfertige Präsente werden bei Bestellungen <b>bis 13:00 Uhr</b> am gleichen Tag versendet (Mo-Fr).
        </Alert> -->

        <Alert type="warning" class="confirmation__alert">
          Bitte überprüfen Sie Ihre Auswahl. Nach diesem Schritt können Sie diese Konfiguration nicht mehr bearbeiten.
        </Alert>

        <Alert type="error" class="confirmation__alert" v-if="showError">
          Die Box konnte nicht in den Warenkorb gelegt werden. Bitte versuchen Sie es später erneut.
        </Alert>

        <Alert type="error" class="confirmation__alert" v-if="showErrorStock">
          Die Box konnte nicht hinzugefügt werden, da einige Produkte nicht mehr Ausreichend vorhanden sind.
        </Alert>

        <!-- present -->
        <section class="confirmation__module">
          <header class="confirmation__module-header">
            <div class="confirmation__module-info">
              <div class="confirmation__module-icon">
                <img
                  v-if="$store.getters.getSelectedItem.data.type === 'level_1' && $store.getters.getSelectedItem.data"
                  :src="`${$store.getters.getSelectedItem.data.photos[$store.getters.groupAbb][0].original}?format=${webPFormat('jpeg')}&width=200&height=200&crop=smart&quality=80&compression=4`"
                  :alt="$store.getters.getSelectedItem.data.name"
                >

                <img
                  v-else
                  :src="`${require('@/assets/images/box.jpg')}?format=${webPFormat('jpeg')}&width=200&height=200&crop=smart&quality=80&compression=4`"
                  alt="Individuelle Präsent"
                >
              </div>

              <div class="confirmation__module-text">
                <h3 class="confirmation__module-name">
                  <slot v-if="$store.getters.getSelectedItem.data.type === 'level_1'">
                    {{ $store.getters.getSelectedQty }}x {{ $store.getters.getSelectedItem.data.name }}
                  </slot>

                  <slot v-else>
                    {{ $store.getters.getSelectedQty }}x Ihr individuelles Präsent
                  </slot>
                </h3>

                <p class="confirmation__module-description">
                  <slot v-if="$store.getters.getSelectedItem.data.type === 'level_1'">
                    Fertiges Präsent
                  </slot>

                  <slot v-else>
                    Individuelles Präsent
                  </slot>

                  • {{ $store.getters.getSelectedItem.qtyProducts() }} Delikatessen
                </p>

                <p class="confirmation__module-description">
                  <a @click="goBack()"><i class="icon icon-edit-alt"></i> Delikatessen bearbeiten</a>
                </p>
              </div>
            </div>

            <div class="confirmation__module-price">
              <Price v-if="$store.getters.getSelectedItem.data.type === 'level_1'">
                <template v-slot:brutto>{{ humanPrice(getPriceRawForGroup($store.getters.getSelectedItem.data, $store.getters.getUserGroupId, false) + getBoxPriceLvl1($store.getters.getSelectedItem.data, $store.getters.getUserGroupId, false)) }}</template>
                <template v-slot:netto>{{ humanPrice(getPriceRawForGroup($store.getters.getSelectedItem.data, $store.getters.getUserGroupId, true) + getBoxPriceLvl1($store.getters.getSelectedItem.data, $store.getters.getUserGroupId, true)) }}</template>
              </Price>

              <Price v-else>
                <template v-slot:brutto>{{ humanPrice(getPriceRawForGroup($store.getters.getSelectedItem.data, $store.getters.getUserGroupId, false) + splittedTaxSingleRaw(getPriceBoxRawForGroup($store.getters.getUserGroupId, false))) }}</template>
                <template v-slot:netto>{{ humanPrice(getPriceRawForGroup($store.getters.getSelectedItem.data, $store.getters.getUserGroupId, true) + getPriceBoxRawForGroup($store.getters.getUserGroupId, true)) }}</template>
              </Price>
            </div>
          </header>

          <div class="confirmation__module-content">
            <ul class="confirmation__products">
              <li
                v-for="(product, index) in ($store.getters.getSelectedItem.data.type === 'level_1' ? getLevel1Items : $store.getters.getSelectedItem.includedProducts())"
                :key="index"
                class="confirmation__product"
              >
                <router-link :to="cLink('/zusammenfassung/details/' + (product.product ? product.product : product.id))">
                  <div class="confirmation__product-photo">
                    <img
                      :src="`${product.photos[$store.getters.groupAbb][0].original}?format=${webPFormat('jpeg')}&width=96`"
                      :alt="product.name"
                    >
                  </div>

                  <p class="confirmation__product-info">
                    <span class="confirmation__product-name">{{ product.name }}</span>
                    <br class="u-dp-none">
                    <small class="confirmation__product-description" v-html="productDetailStringBold1(product)"></small>
                  </p>

                  <!-- only show if level 3 -->
                  <div
                    v-if="$store.getters.getSelectedItem.data.type === 'level_3'"
                    class="confirmation__product-price"
                  >
                    <Price>
                      <template v-slot:netto>{{ getPriceLevel3ForGroup(product, $store.getters.getUserGroupId, true) }}</template>
                      <template v-slot:brutto>{{ getPriceLevel3ForGroup(product, $store.getters.getUserGroupId, false) }}</template>
                    </Price>
                  </div>
                  <!-- /only show if level 3 -->
                </router-link>
              </li>
            </ul>
          </div>
        </section>
        <!-- /present -->

        <!-- postcard -->
        <section
          class="confirmation__module"
        >
          <header class="confirmation__module-header">
            <div class="confirmation__module-info">
              <div class="confirmation__module-icon" v-if="$store.getters.getComposerModules.postcard.main.mode === 1 && $store.getters.getComposerModules.postcard.motive.mode === 1">
                <img
                  :src="`${$store.getters.getSelectedPostcard.image}?format=${webPFormat('jpeg')}&width=200`"
                  class="confirmation__postcard-motive"
                >
              </div>

              <div class="confirmation__module-text">
                <h3 class="confirmation__module-name">Grußkarte</h3>
                <p class="confirmation__module-description" v-if="$store.getters.getComposerModules.postcard.main.mode === 2">Externe Grußkarte</p>
                <p class="confirmation__module-description" v-else-if="$store.getters.getComposerModules.postcard.main.mode === 3">Keine Grußkarte</p>
                <p class="confirmation__module-description" v-else-if="$store.getters.getComposerModules.postcard.main.mode === 4">Grußkarte später festlegen</p>
                <slot v-if="$store.getters.getComposerModules.postcard.main.mode === 1">
                  <p class="confirmation__module-description" v-if="$store.getters.getComposerModules.postcard.message.mode === 1">Handgeschriebene Grußkarte</p>
                  <p class="confirmation__module-description" v-else-if="$store.getters.getComposerModules.postcard.message.mode === 2">Gedruckte Grußkarte</p>
                  <p class="confirmation__module-description" v-else-if="$store.getters.getComposerModules.postcard.message.mode === 3">Ohne Grußtext</p>
                  <p class="confirmation__module-description" v-else-if="$store.getters.getComposerModules.postcard.message.mode === 4">Text später festlegen</p>
                </slot>

                <p class="confirmation__module-description">
                  <a @click="goBack('#postcard')"><i class="icon icon-edit-alt"></i> Grußkarte bearbeiten</a>
                </p>
              </div>
            </div>

            <div class="confirmation__module-price" v-if="composerPrices.filter(e => e.key.startsWith('postcard')).length > 0">
              <Price>
                <template v-slot:brutto>{{ humanPrice(composerPrices.filter(e => e.key.startsWith('postcard')).map(e => e.singlePriceRaw).reduce((e1, e2) => { return e1 + e2}, 0)) }}</template>
                <template v-slot:netto>{{ humanPrice(composerPrices.filter(e => e.key.startsWith('postcard')).map(e => e.netSinglePriceRaw).reduce((e1, e2) => { return e1 + e2}, 0)) }}</template>
              </Price>
            </div>
          </header>

          <div class="confirmation__module-content" v-if="$store.getters.getComposerModules.postcard.main.mode === 1">
            <div class="grid-noBottom_xs-1">
              <div class="col">
                <p class="u-text-dimmed"><b>Ausgewählte Optionen:</b></p>

                <ul class="confirmation__selected-options">
                  <li>Grußkarte von Componata</li>
                  <li v-if="boxQty >= $store.getters.getOrderQtySize.md.min && $store.getters.getComposerModules.postcard.motive.mode === 2">Eigenes Motiv</li>
                  <li v-if="$store.getters.getComposerModules.postcard.message.option === '1'">Gleicher Text</li>
                  <li v-if="$store.getters.getComposerModules.postcard.message.option === '2'">Gleicher Text mit persönlicher Anrede</li>
                  <li v-if="$store.getters.getComposerModules.postcard.message.option === '3'">Unterschiedliche Texte</li>

                  <li v-if="boxQty >= $store.getters.getOrderQtySize.sm.min && $store.getters.getComposerModules.postcard.addons.backLogo">Mit Logo</li>
                  <li v-if="boxQty >= $store.getters.getOrderQtySize.md.min && $store.getters.getComposerModules.postcard.addons.caseLogo">Box-Branding in Schuber</li>
                </ul>
              </div>

              <div class="col" v-if="$store.getters.getComposerModules.postcard.main.mode === 1 && $store.getters.getComposerModules.postcard.message.option.toString() === '1' && ($store.getters.getComposerModules.postcard.message.mode === 1 || $store.getters.getComposerModules.postcard.message.mode === 2)">
                <p class="u-text-dimmed"><b>Grußkartentext:</b></p>

                <blockquote class="confirmation__postcard-message">
                  {{ $store.getters.getComposerModules.postcard.message.text }}
                </blockquote>
              </div>
            </div>
          </div>
        </section>
        <!-- /postcard -->

        <!-- shipping -->
        <section class="confirmation__module">
          <header class="confirmation__module-header">
            <div class="confirmation__module-info">
              <div class="confirmation__module-icon">
                <img src="@/assets/images/icon-delivery-truck-blue.svg">
              </div>

              <div class="confirmation__module-text">
                <h3 class="confirmation__module-name">Lieferung</h3>
                <p class="confirmation__module-description" v-if="$store.getters.getComposerModules.shipping.main.mode === 1">Versand an Beschenkte</p>
                <p class="confirmation__module-description" v-else-if="$store.getters.getComposerModules.shipping.main.mode === 2">Versand an dich</p>
                <p class="confirmation__module-description" v-else-if="$store.getters.getComposerModules.shipping.main.mode === 3">Einzelversand an Beschenkte</p>
                <p class="confirmation__module-description" v-else-if="$store.getters.getComposerModules.shipping.main.mode === 4">Sammelversand</p>
                <p class="confirmation__module-description" v-else-if="$store.getters.getComposerModules.shipping.main.mode === 5">Kombinationsversand</p>
                <p class="confirmation__module-description" v-else-if="$store.getters.getComposerModules.shipping.main.mode === 6">Nach der Bestellung festlegen</p>

                <p class="confirmation__module-description">
                  <a @click="goBack('#shipping')"><i class="icon icon-edit-alt"></i> Lieferoptionen bearbeiten</a>
                </p>
              </div>
            </div>

            <div class="confirmation__module-price" v-if="composerPrices.filter(e => e.key.startsWith('shipping')).length > 0">
              <Price>
                <template v-slot:brutto>{{ composerPrices.filter(e => e.key.startsWith('shipping')).length > 1 ? 'Ø ' : ''}}{{ humanPrice(composerPrices.filter(e => e.key.startsWith('shipping')).map(e => e.multPriceRaw).reduce((e1, e2) => { return e1 + e2}, 0) / boxQty) }}</template>
                <template v-slot:netto>{{ composerPrices.filter(e => e.key.startsWith('shipping')).length > 1 ? 'Ø ' : ''}}{{ humanPrice(composerPrices.filter(e => e.key.startsWith('shipping')).map(e => e.netMultPriceRaw).reduce((e1, e2) => { return e1 + e2}, 0) / boxQty) }}</template>
              </Price>
            </div>
          </header>

          <div class="confirmation__module-content">
            <div class="grid-noBottom_xs-1">
              <div class="col">
                <p class="u-text-dimmed"><b>Ausgewählte Optionen:</b></p>

                <ul class="confirmation__selected-options">
                  <slot v-if="$store.getters.getComposerModules.shipping.main.mode === 1">
                    <li>Versand an Beschenkte</li>
                    <li v-if="$store.getters.getComposerModules.shipping.single.option === 1">Lieferung sofort</li>
                    <li v-else>Lieferung verzögert, {{ displayDateFromDesired($store.getters.getComposerModules.shipping.single.desiredShippingDate) }}</li>
                    <li v-if="$store.getters.getComposerModules.shipping.single.region === 'de'">Versand innerhalb Deutschlands</li>
                    <li v-else-if="$store.getters.getComposerModules.shipping.single.region === 'eu'">Versand innerhalb Europas</li>
                    <li v-else-if="$store.getters.getComposerModules.shipping.single.region === 'ch_uk'">Versand innerhalb Schweiz und Vereinigtes Königreich</li>
                    <li v-else-if="$store.getters.getComposerModules.shipping.single.region === 'other'">Versand Rest der Welt</li>
                  </slot>
                  <slot v-else-if="$store.getters.getComposerModules.shipping.main.mode === 2">
                    <li>Versand an dich</li>
                    <li v-if="$store.getters.getComposerModules.shipping.single.option === 1">Lieferung sofort</li>
                    <li v-else>Lieferung verzögert, {{ displayDateFromDesired($store.getters.getComposerModules.shipping.single.desiredShippingDate) }}</li>
                    <li v-if="!$store.getters.getComposerModules.shipping.single.international">Versand innerhalb Deutschlands</li>
                    <li v-else-if="$store.getters.getComposerModules.shipping.single.international && $store.getters.getComposerModules.shipping.single.region === 'eu'">Versand innerhalb Europas</li>
                    <li v-else-if="$store.getters.getComposerModules.shipping.single.international && $store.getters.getComposerModules.shipping.single.region === 'other'">Versand Rest der Welt</li>
                  </slot>
                  <slot v-else-if="$store.getters.getComposerModules.shipping.main.mode === 3">
                    <li>Einzelversand an Beschenkte</li>
                    <li v-if="!$store.getters.getComposerModules.shipping.individual.international">Versand innerhalb Deutschlands</li>
                    <slot v-else>
                      <li v-if="$store.getters.getComposerModules.shipping.individual.regions.de > 0">{{ $store.getters.getComposerModules.shipping.individual.regions.de }}x Deutschland</li>
                      <li v-if="$store.getters.getComposerModules.shipping.individual.regions.eu > 0">{{ $store.getters.getComposerModules.shipping.individual.regions.eu }}x EU</li>
                      <li v-if="$store.getters.getComposerModules.shipping.individual.regions.ch_uk > 0">{{ $store.getters.getComposerModules.shipping.individual.regions.ch_uk }}x Schweiz / Vereinigtes Königreich</li>
                      <li v-if="$store.getters.getComposerModules.shipping.individual.regions.other > 0">{{ $store.getters.getComposerModules.shipping.individual.regions.other }}x Rest der Welt</li>
                    </slot>
                  </slot>
                  <slot v-else-if="$store.getters.getComposerModules.shipping.main.mode === 4">
                    <li>Sammelversand</li>
                    <li v-if="$store.getters.getComposerModules.shipping.bulk.multipleLocations">2 Standorte oder mehr</li>
                    <li v-else>1 Standort</li>

                    <li v-if="!$store.getters.getComposerModules.shipping.bulk.international">Versand innerhalb Deutschlands</li>
                    <li v-else>Ausland Versand</li>

                    <li v-if="$store.getters.getComposerModules.shipping.bulk.cardboardBoxWrap">Präsent in Einzelversandkarton</li>
                  </slot>
                  <slot v-else-if="$store.getters.getComposerModules.shipping.main.mode === 5">
                    <li>Kombinationsversand</li>
                    <slot v-if="$store.getters.getComposerModules.shipping.combined.international">
                      <li v-if="$store.getters.getComposerModules.shipping.combined.splitting.international.single.de > 0">{{ $store.getters.getComposerModules.shipping.combined.splitting.international.single.de }}x Deutschland einzeln</li>
                      <li v-if="$store.getters.getComposerModules.shipping.combined.splitting.international.single.eu > 0">{{ $store.getters.getComposerModules.shipping.combined.splitting.international.single.eu }}x EU einzeln</li>
                      <li v-if="$store.getters.getComposerModules.shipping.combined.splitting.international.single.ch_uk > 0">{{ $store.getters.getComposerModules.shipping.combined.splitting.international.single.ch_uk }}x Schweiz / Vereinigtes Königreich einzeln</li>
                      <li v-if="$store.getters.getComposerModules.shipping.combined.splitting.international.single.other > 0">{{ $store.getters.getComposerModules.shipping.combined.splitting.international.single.other }}x Rest der Welt einzeln</li>
                      <li v-if="$store.getters.getComposerModules.shipping.combined.splitting.international.bulk.de > 0">{{ $store.getters.getComposerModules.shipping.combined.splitting.international.bulk.de }}x Deutschland geschlossen</li>
                      <li v-if="$store.getters.getComposerModules.shipping.combined.splitting.international.bulk.other > 0">{{ $store.getters.getComposerModules.shipping.combined.splitting.international.bulk.other }}x Rest der Welt geschlossen</li>
                    </slot>
                    <slot v-else>
                      <li v-if="$store.getters.getComposerModules.shipping.combined.splitting.national.single > 0">{{ $store.getters.getComposerModules.shipping.combined.splitting.national.single }}x Deutschland einzeln</li>
                      <li v-if="$store.getters.getComposerModules.shipping.combined.splitting.national.bulk > 0">{{ $store.getters.getComposerModules.shipping.combined.splitting.national.bulk }}x Deutschland geschlossen</li>
                    </slot>
                  </slot>
                  <slot v-else-if="$store.getters.getComposerModules.shipping.main.mode === 6">
                    <li>Nach der Bestellung festlegen</li>
                  </slot>
                </ul>
                <p v-if="($store.getters.getComposerModules.shipping.combined.splitting.international.bulk.other != $store.getters.getSelectedQty) && ($store.getters.getComposerModules.shipping.bulk.regions.other != $store.getters.getSelectedQty)"><br/>Die angegebenen Kosten enthalten neben dem reinen Porto auch die Versandverpackung (z.B. Kartons, Füllmaterial) sowie deren Handling.</p>
              </div>
            </div>
          </div>
        </section>
        <!-- /shipping -->

        <!-- total -->
        <section class="confirmation__module">
          <header class="confirmation__module-header">
            <div class="confirmation__module-info">
              <div class="confirmation__module-text">
                <h3 class="confirmation__module-name">Gesamtpreis pro Präsent</h3>
              </div>
            </div>

            <div class="confirmation__module-price">
              <Price>
                <template v-slot:brutto>{{ composerPrices.filter(e => e.key.startsWith('shipping')).length > 1 ? 'Ø ' : ''}}{{ humanPrice(composerPrices.map(e => e.multPriceRaw).reduce((e1, e2) => { return e1 + e2}, 0) / boxQty) }}</template>
                <template v-slot:netto>{{ composerPrices.filter(e => e.key.startsWith('shipping')).length > 1 ? 'Ø ' : ''}}{{ humanPrice(composerPrices.map(e => e.netMultPriceRaw).reduce((e1, e2) => { return e1 + e2}, 0) / boxQty) }}</template>
              </Price>
            </div>
          </header>
        </section>
        <!-- /total -->

        <!-- actions -->
        <footer class="confirmation__footer">
          <slot v-if="$store.getters.getUserGroupId === 8442 || $store.getters.getUserGroupId === '8442'">
            <Button @click="addToCart('coupa', true)" class="confirmation__button" type="button" appearance="primary">Zurück zu Coupa</Button>
          </slot>

          <slot v-else-if="$store.getters.getArag.active">
            <Button @click="addToCart('arag', true)" class="confirmation__button" type="button" appearance="primary">Über OCI bestellen</Button>
          </slot>

          <slot v-else>
            <div>
              <Button @click="addToCart('shop', false)" class="confirmation__button" type="button" appearance="secondary" :disabled="$store.getters.getSelectedItem.qtyProducts() === 0">Weiteres Präsent erstellen</Button>
            </div>

            <div>
              <Button @click="addToCart('shop', true)" class="confirmation__button" type="button" appearance="primary" :disabled="$store.getters.getSelectedItem.qtyProducts() === 0">zur Kasse <i class="icon icon-angle-right"></i></Button>
            </div>
          </slot>
        </footer>
        <!-- /actions -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import BoxState from '@/model/Box';

import { logicMixin } from '@/mixins/LogicMixin';
import { loadingMixin } from '@/mixins/LoadingMixin';
import { helperMixin } from '@/mixins/HelperMixin';

import Alert from '@/components/Alert';
import Price from '@/components/Common/Price';
import Button from '@/components/Common/Button';

export default {
  name: 'Confirmation',
  components: {
    Alert,
    Price,
    Button
  },
  mixins: [logicMixin, loadingMixin, helperMixin],
  data: function () {
    return {
      showError: false,
      showErrorStock: false,
      clickedAddedToCart: false,
      level1Loaded: false,
      level3Loaded: false,
    };
  },
  created: function () {
    this.init();
    this.$root.$on('level1Loaded', () => {
      this.level1Loaded = true;
      if (this.level1Loaded && this.level3Loaded) {
        if (this.$store.getters.getSelectedItem.data === null) {
          this.$router.push(this.cLink('/'));
        }
        this.init();
      }
    });
    this.$root.$on('level3Loaded', () => {
      this.level3Loaded = true;
      if (this.level1Loaded && this.level3Loaded) {
        if (this.$store.getters.getSelectedItem.data === null) {
          this.$router.push(this.cLink('/'));
        }
        this.init();
      }
    });
  },
  methods: {
    getDeliveryTimeString () {
      // if ([62, 2569, 2571, 2548].includes(parseInt(this.$store.getters.getUserGroupId))) return 'Spätestens KW 51';
      const days = this.$store.getters.getSelectedItem.getDeliveryTime(this.$store);
      if (days === 0 || days === 1) return 'sofort versandfertig';
      if (days > 1 && days <= 14) return `in ${days} Tagen versandfertig`;
      return `am ${this.getDeliveryReadyDateString(days)} versandfertig`;
    },
    init: function () {
      const composerItem = sessionStorage.getItem('composerItem');
      if (composerItem !== null) {
        this.modules = JSON.parse(composerItem);
        this.$store.commit('setComposerModules', JSON.parse(composerItem));
      } else {
        this.$router.push(this.cLink('/'));
      }
      // change composer module object
      if (this.modules.shipping.main.mode === 5) {
        const changeModules = this.$store.getters.getComposerModules;
        if (
          changeModules.shipping.combined.international === false &&
        changeModules.shipping.combined.splitting.national.single === this.boxQty
        ) {
          // Einzelversand Deutschland
          changeModules.shipping.main.mode = 3;
          changeModules.shipping.individual.international = false;
          changeModules.shipping.individual.regions.de = this.boxQty;
          changeModules.shipping.individual.regions.eu = 0;
          changeModules.shipping.individual.regions.ch_uk = 0;
          changeModules.shipping.individual.regions.other = 0;
        } else if (
          changeModules.shipping.combined.international === true &&
        changeModules.shipping.combined.splitting.international.single.de + changeModules.shipping.combined.splitting.international.single.eu + changeModules.shipping.combined.splitting.international.single.ch_uk + changeModules.shipping.combined.splitting.international.single.other === this.boxQty
        ) {
          // Einzelversand International
          changeModules.shipping.main.mode = 3;
          changeModules.shipping.individual.international = true;
          changeModules.shipping.individual.regions.de = changeModules.shipping.combined.splitting.international.single.de;
          changeModules.shipping.individual.regions.eu = changeModules.shipping.combined.splitting.international.single.eu;
          changeModules.shipping.individual.regions.ch_uk = changeModules.shipping.combined.splitting.international.single.ch_uk;
          changeModules.shipping.individual.regions.other = changeModules.shipping.combined.splitting.international.single.other;
        } else if (
          changeModules.shipping.combined.international === false &&
        changeModules.shipping.combined.splitting.national.bulk === this.boxQty
        ) {
          // Großversand Deutschland
          changeModules.shipping.main.mode = 4;
          changeModules.shipping.bulk.multipleLocations = false;
          changeModules.shipping.bulk.international = false;
          changeModules.shipping.bulk.regions.de = this.boxQty;
          changeModules.shipping.bulk.regions.other = 0;
        } else if (
          changeModules.shipping.combined.international === true &&
        changeModules.shipping.combined.splitting.international.bulk.de === this.boxQty
        ) {
          // Großversand International aber nur Deutschland
          changeModules.shipping.main.mode = 4;
          changeModules.shipping.bulk.multipleLocations = false;
          changeModules.shipping.bulk.international = false;
          changeModules.shipping.bulk.regions.de = this.boxQty;
          changeModules.shipping.bulk.regions.other = 0;
        } else if (
          changeModules.shipping.combined.international === true &&
        changeModules.shipping.combined.splitting.international.bulk.other === this.boxQty
        ) {
          // Großversand International
          changeModules.shipping.main.mode = 4;
          changeModules.shipping.bulk.multipleLocations = false;
          changeModules.shipping.bulk.international = true;
          changeModules.shipping.bulk.regions.de = 0;
          changeModules.shipping.bulk.regions.other = this.boxQty;
        } else if (
          changeModules.shipping.combined.international === true &&
        changeModules.shipping.combined.splitting.international.bulk.de + changeModules.shipping.combined.splitting.international.bulk.other === this.boxQty
        ) {
          // Großversand Gesplittet
          changeModules.shipping.main.mode = 4;
          changeModules.shipping.bulk.multipleLocations = true;
          changeModules.shipping.bulk.international = false;
          changeModules.shipping.bulk.regions.de = changeModules.shipping.combined.splitting.international.bulk.de;
          changeModules.shipping.bulk.regions.other = changeModules.shipping.combined.splitting.international.bulk.other;
        }

        this.modules = changeModules;
        this.$store.commit('setComposerModules', changeModules);
        sessionStorage.setItem('composerItem', JSON.stringify(changeModules));
      }

      this.$store.commit('setGlobalLoading', true);
      var lastSelectedType = '';
      if (localStorage.getItem('lastSelectedType') !== null) {
        lastSelectedType = localStorage.getItem('lastSelectedType');
      }
      if (
        (localStorage.getItem('lastSelectedItem') !== null ||
        localStorage.getItem('lastSelectedItemLevel3') !== null)
      ) {
        if (
          localStorage.getItem('lastSelectedItem') !== null &&
        lastSelectedType === 'level_1'
        ) {
          const savedItem = JSON.parse(localStorage.getItem('lastSelectedItem'));
          this.$store.getters.getListItemsLevel1.forEach((item) => {
            if (this._.isEqual(item, savedItem)) {
              this.$store.commit('setSelectedItem', item);
              // this.$store.commit('setListItemsLevel1', [item]);
              this.setLastQty();
            }
          });
        } else if (
          localStorage.getItem('lastSelectedItemLevel3') !== null &&
        lastSelectedType === 'level_3'
        ) {
          const savedItem = JSON.parse(
            localStorage.getItem('lastSelectedItemLevel3')
          );
          const ids = [];
          savedItem.data.products.forEach((product) => {
            ids.push(product.id);
          });
          var canLoad = true;
          var isIn = false;
          savedItem.data.products.forEach(savedProduct => {
            this.$store.getters.getListItemsLevel3.forEach((item) => {
              if (savedProduct.id === item.id) {
                if (
                  this._.isEqual(item.dim_x, savedProduct.dim_x) &&
                this._.isEqual(item.dim_y, savedProduct.dim_y) &&
                this._.isEqual(
                  item.originalPrice,
                  savedProduct.originalPrice
                ) &&
                this._.isEqual(
                  item.originalPriceNet,
                  savedProduct.originalPriceNet
                ) &&
                this._.isEqual(item.price, savedProduct.price) &&
                this._.isEqual(item.rotatable, savedProduct.rotatable) &&
                this._.isEqual(
                  item.stock_quantity,
                  savedProduct.stock_quantity
                ) &&
                this._.isEqual(
                  item.custom_delivery_qty,
                  savedProduct.custom_delivery_qty
                )
                ) {
                  isIn = true;
                } else {
                  canLoad = false;
                }
              }
            });
          });

          if (!isIn) {
            canLoad = false;
          }

          if (canLoad) {
            this.$store.commit('setSelectedItem', savedItem.data);
          }
        }
      }
      this.$store.commit('setGlobalLoading', false);
    },
    addToCart: function (endpoint, redirect) {
      if (this.clickedAddedToCart) {
        return;
      }
      this.clickedAddedToCart = true;
      this.$store.commit('setGlobalLoading', true);
      var dataObject = {};
      if (this.$store.getters.getSelectedItem.data.type === 'level_1') {
        dataObject = { ...this.$store.getters.getComposerModules, replaced: this.getReplaceRawSku() };
        dataObject.present.conf.icon = '';
        dataObject.postcard.conf.icon = '';
        dataObject.shipping.conf.icon = '';
        axios
          .post(
            process.env.VUE_APP_BASE_URL +
              '/wp-json/geschenkbox/v1/cart/addLevel1ToCart?add_customer_group=' +
              this.$store.getters.getUserGroupId,
            {
              level_1_id: this.$store.getters.getSelectedItem.data.id,
              qty: parseInt(this.$store.getters.getSelectedQty),
              postcard: this.$store.getters.getSelectedPostcard,
              endpoint: endpoint,
              dataObject,
              prepackgaged: this.$store.getters.getSelectedItem.data.prepackaged,
              delivery_time: this.getDeliveryTimeString(),
              replace: this.getReplaceRaw(),
              use_group_id: this.$store.getters.getUserGroupId,
              isB2b: this.$store.getters.isB2b
            }
          )
          .then((response) => {
            if (response.status === 200 && this.$store.getters.getArag.active) {
              var hiddenInputs = '';
              Object.keys(this.$store.getters.getArag.data).forEach(k => {
                if (k !== 'HOOK_URL') {
                  hiddenInputs += '<input type="hidden" name="' + k + '" value="' + this.$store.getters.getArag.data[k] + '">';
                }
              });
              var nb = 1;
              var productInputs = '';
              var priceSplitted = this.splittedTaxSingleRawSum((this.getPriceRawForGroup(this.$store.getters.getSelectedItem.data, this.$store.getters.getUserGroupId, false) + this.getBoxPriceLvl1(this.$store.getters.getSelectedItem.data, this.$store.getters.getUserGroupId, false)));
              if (priceSplitted.tax7 > 0) {
                productInputs += '<input type="hidden" name="NEW_ITEM-DESCRIPTION[' + nb + ']" value="' + this.$store.getters.getSelectedItem.data.name + ' 7%">';
                productInputs += '<input type="hidden" name="NEW_ITEM-QUANTITY[' + nb + ']" value="' + this.$store.getters.getSelectedQty + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-UNIT[' + nb + ']" value="H87">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICE[' + nb + ']" value="' + priceSplitted.tax7 + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CURRENCY[' + nb + ']" value="EUR">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICEUNIT[' + nb + ']" value="1">';
                productInputs += '<input type="hidden" name="NEW_ITEM-LEADTIME[' + nb + ']" value="' + this.$store.getters.getSelectedItem.getDeliveryTime(this.$store) + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-VENDORMAT[' + nb + ']" value="' + this.$store.getters.getSelectedItem.data.id + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-MATGROUP[' + nb + ']" value="Gift">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD1[' + nb + ']" value="7">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD5[' + nb + ']" value="' + response.data.orderId + '">';
                ++nb;
              }
              if (priceSplitted.tax19 > 0) {
                productInputs += '<input type="hidden" name="NEW_ITEM-DESCRIPTION[' + nb + ']" value="' + this.$store.getters.getSelectedItem.data.name + ' 19%">';
                productInputs += '<input type="hidden" name="NEW_ITEM-QUANTITY[' + nb + ']" value="' + this.$store.getters.getSelectedQty + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-UNIT[' + nb + ']" value="H87">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICE[' + nb + ']" value="' + priceSplitted.tax19 + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CURRENCY[' + nb + ']" value="EUR">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICEUNIT[' + nb + ']" value="1">';
                productInputs += '<input type="hidden" name="NEW_ITEM-LEADTIME[' + nb + ']" value="' + this.$store.getters.getSelectedItem.getDeliveryTime(this.$store) + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-VENDORMAT[' + nb + ']" value="' + this.$store.getters.getSelectedItem.data.id + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-MATGROUP[' + nb + ']" value="Gift">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD1[' + nb + ']" value="19">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD5[' + nb + ']" value="' + response.data.orderId + '">';
                ++nb;
              }

              priceSplitted = this.splittedTaxSingleRawSum(this.composerPrices.filter(e => e.key.startsWith('shipping')).map(e => e.multPriceRaw).reduce((e1, e2) => { return e1 + e2; }, 0) / this.boxQty);
              if (priceSplitted.tax7 > 0) {
                productInputs += '<input type="hidden" name="NEW_ITEM-DESCRIPTION[' + nb + ']" value="Versand 7%">';
                productInputs += '<input type="hidden" name="NEW_ITEM-QUANTITY[' + nb + ']" value="' + this.$store.getters.getSelectedQty + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-UNIT[' + nb + ']" value="H87">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICE[' + nb + ']" value="' + priceSplitted.tax7 + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CURRENCY[' + nb + ']" value="EUR">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICEUNIT[' + nb + ']" value="1">';
                productInputs += '<input type="hidden" name="NEW_ITEM-LEADTIME[' + nb + ']" value="' + this.$store.getters.getSelectedItem.getDeliveryTime(this.$store) + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-VENDORMAT[' + nb + ']" value="0">';
                productInputs += '<input type="hidden" name="NEW_ITEM-MATGROUP[' + nb + ']" value="Shipping">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD1[' + nb + ']" value="7">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD5[' + nb + ']" value="' + response.data.orderId + '">';
                ++nb;
              }
              if (priceSplitted.tax19 > 0) {
                productInputs += '<input type="hidden" name="NEW_ITEM-DESCRIPTION[' + nb + ']" value="Versand 19%">';
                productInputs += '<input type="hidden" name="NEW_ITEM-QUANTITY[' + nb + ']" value="' + this.$store.getters.getSelectedQty + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-UNIT[' + nb + ']" value="H87">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICE[' + nb + ']" value="' + priceSplitted.tax19 + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CURRENCY[' + nb + ']" value="EUR">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICEUNIT[' + nb + ']" value="1">';
                productInputs += '<input type="hidden" name="NEW_ITEM-LEADTIME[' + nb + ']" value="' + this.$store.getters.getSelectedItem.getDeliveryTime(this.$store) + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-VENDORMAT[' + nb + ']" value="0">';
                productInputs += '<input type="hidden" name="NEW_ITEM-MATGROUP[' + nb + ']" value="Shipping">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD1[' + nb + ']" value="19">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD5[' + nb + ']" value="' + response.data.orderId + '">';
                ++nb;
              }

              if (this.$store.getters.getComposerModules.postcard.main.mode === 1) {
                productInputs += '<input type="hidden" name="NEW_ITEM-DESCRIPTION[' + nb + ']" value="Grußkarte ' + this.$store.getters.getPostcards.filter(p => p.id === this.$store.getters.getSelectedPostcard.id)[0].name.substr(0, 30) + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-LONGTEXT_' + nb + ':132" value="' + this.$store.getters.getComposerModules.postcard.message.text + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-QUANTITY[' + nb + ']" value="' + this.$store.getters.getSelectedQty + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-UNIT[' + nb + ']" value="H87">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICE[' + nb + ']" value="0.01">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CURRENCY[' + nb + ']" value="EUR">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICEUNIT[' + nb + ']" value="1">';
                productInputs += '<input type="hidden" name="NEW_ITEM-LEADTIME[' + nb + ']" value="' + this.$store.getters.getSelectedItem.getDeliveryTime(this.$store) + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-VENDORMAT[' + nb + ']" value="0">';
                productInputs += '<input type="hidden" name="NEW_ITEM-MATGROUP[' + nb + ']" value="Card">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD1[' + nb + ']" value="7">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD5[' + nb + ']" value="' + response.data.orderId + '">';
                ++nb;
              }

              if (this.composerPrices.filter(e => e.key.startsWith('postcard')).length > 0) {
                priceSplitted = this.splittedTaxSingleRawSum(this.composerPrices.filter(e => e.key.startsWith('postcard')).map(e => e.singlePriceRaw).reduce((e1, e2) => { return e1 + e2; }, 0));
                if (priceSplitted.tax7 > 0) {
                  productInputs += '<input type="hidden" name="NEW_ITEM-DESCRIPTION[' + nb + ']" value="Grußkartenextras 7%">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-QUANTITY[' + nb + ']" value="' + this.$store.getters.getSelectedQty + '">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-UNIT[' + nb + ']" value="H87">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-PRICE[' + nb + ']" value="' + priceSplitted.tax7 + '">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-CURRENCY[' + nb + ']" value="EUR">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-PRICEUNIT[' + nb + ']" value="1">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-LEADTIME[' + nb + ']" value="' + this.$store.getters.getSelectedItem.getDeliveryTime(this.$store) + '">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-VENDORMAT[' + nb + ']" value="0">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-MATGROUP[' + nb + ']" value="Extra">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD1[' + nb + ']" value="7">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD5[' + nb + ']" value="' + response.data.orderId + '">';
                  ++nb;
                }
                if (priceSplitted.tax19 > 0) {
                  productInputs += '<input type="hidden" name="NEW_ITEM-DESCRIPTION[' + nb + ']" value="Grußkartenextras 19%">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-QUANTITY[' + nb + ']" value="' + this.$store.getters.getSelectedQty + '">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-UNIT[' + nb + ']" value="H87">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-PRICE[' + nb + ']" value="' + priceSplitted.tax19 + '">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-CURRENCY[' + nb + ']" value="EUR">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-PRICEUNIT[' + nb + ']" value="1">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-LEADTIME[' + nb + ']" value="' + this.$store.getters.getSelectedItem.getDeliveryTime(this.$store) + '">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-VENDORMAT[' + nb + ']" value="0">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-MATGROUP[' + nb + ']" value="Extra">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD1[' + nb + ']" value="19">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD5[' + nb + ']" value="' + response.data.orderId + '">';
                  ++nb;
                }
              }
              const formStr =
                '<form method="post" action="' +
                this.$store.getters.getArag.data.HOOK_URL +
                '" id="formToSubmit">' + hiddenInputs + productInputs + '</form>"';
              const div = document.createElement('div');
              div.innerHTML = formStr;
              document.body.appendChild(div);
              document.getElementById('formToSubmit').submit();
            } else if (response.status === 200 && 'url' in response.data) {
              localStorage.removeItem('lastSelectedItem');
              localStorage.removeItem('lastSelectedQty');
              localStorage.removeItem('lastSelectedPostcard');
              sessionStorage.removeItem('composerItem');
              if (redirect) {
                window.location.href = response.data.url;
              } else {
                this.$store.commit('setGlobalLoading', false);
                this.$router.push(this.cLink('/'));
              }
            } else if (response.status === 200 && 'content' in response.data) {
              const formStr =
                '<form method="post" action="' +
                response.data.checkout_url +
                '" id="formToSubmit"><input type="hidden" name="cXML-urlencoded" value=\'' +
                response.data.content +
                "'></form>";
              const div = document.createElement('div');
              div.innerHTML = formStr;
              document.body.appendChild(div);
              document.getElementById('formToSubmit').submit();
            } else if (response.status === 200 && 'custom_error' in response.data && response.data.custom_error === 'no_stock') {
              this.showErrorStock = true;
              this.$store.commit('setGlobalLoading', false);
              this.clickedAddedToCart = false;
            } else {
              this.showError = true;
              this.$store.commit('setGlobalLoading', false);
              this.clickedAddedToCart = false;
            }
          })
          .catch((_) => {
            this.showError = true;
            this.$store.commit('setGlobalLoading', false);
            this.clickedAddedToCart = false;
          });
      } else if (this.$store.getters.getSelectedItem.data.type === 'level_3') {
        var areaProducts = 0;
        this.$store.getters.getSelectedItem.data.products.forEach(p => {
          areaProducts += p.dim_x * p.dim_y;
        });
        var boxArea = {};
        this.$store.getters.getBoxItemsLevel3.forEach(box => {
          const area = (box.dim_x + 3) * (box.dim_y + 3);
          if (area >= areaProducts) {
            boxArea = {
              name: box.name,
              area,
              areaProducts,
              percent: ((areaProducts * 100) / area).toFixed(2)
            };
          }
        });
        const checker = new BoxState();
        checker.products = this.$store.getters.getSelectedItem.data.products;
        var result = {};

        for (
          var i = this.$store.getters.getBoxItemsLevel3.length - 1;
          i >= 0;
          --i
        ) {
          result = checker.currentStatus(
            this.$store.getters.getBoxItemsLevel3[i]
          );
          if (result.remainingProducts.length === 0) {
            break;
          }
        }
        dataObject = { ...this.$store.getters.getComposerModules, replaced: this.getReplaceRawSku() };
        dataObject.present.conf.icon = '';
        dataObject.postcard.conf.icon = '';
        dataObject.shipping.conf.icon = '';
        axios
          .post(
            process.env.VUE_APP_BASE_URL +
              '/wp-json/geschenkbox/v1/cart/addLevel3ToCart?add_customer_group=' +
              this.$store.getters.getUserGroupId,
            {
              configuredBox: result,
              qty: parseInt(this.$store.getters.getSelectedQty),
              postcard: this.$store.getters.getSelectedPostcard,
              endpoint: endpoint,
              dataObject,
              delivery_time: this.getDeliveryTimeString(),
              boxArea,
              use_group_id: this.$store.getters.getUserGroupId,
              isB2b: this.$store.getters.isB2b
            }
          )
          .then((response) => {
            if (response.status === 200 && this.$store.getters.getArag.active) {
              var hiddenInputs = '';
              Object.keys(this.$store.getters.getArag.data).forEach(k => {
                if (k !== 'HOOK_URL') {
                  hiddenInputs += '<input type="hidden" name="' + k + '" value="' + this.$store.getters.getArag.data[k] + '">';
                }
              });
              var nb = 1;
              var productInputs = '';
              var priceSplitted = this.splittedTaxSingleRawSum(this.getPriceBoxForGroup(this.$store.getters.getUserGroupId, false).replace('€', '').replace(' ', '').replace('.', '').replace(',', '.'));
              if (priceSplitted.tax7 > 0) {
                productInputs += '<input type="hidden" name="NEW_ITEM-DESCRIPTION[' + nb + ']" value="' + result.name + ' 7%">';
                productInputs += '<input type="hidden" name="NEW_ITEM-QUANTITY[' + nb + ']" value="' + this.$store.getters.getSelectedQty + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-UNIT[' + nb + ']" value="H87">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICE[' + nb + ']" value="' + priceSplitted.tax7 + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CURRENCY[' + nb + ']" value="EUR">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICEUNIT[' + nb + ']" value="1">';
                productInputs += '<input type="hidden" name="NEW_ITEM-LEADTIME[' + nb + ']" value="' + this.$store.getters.getSelectedItem.getDeliveryTime(this.$store) + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-VENDORMAT[' + nb + ']" value="' + result.id + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-MATGROUP[' + nb + ']" value="Gift">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD1[' + nb + ']" value="7">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD5[' + nb + ']" value="' + response.data.orderId + '">';
                ++nb;
              }
              if (priceSplitted.tax19 > 0) {
                productInputs += '<input type="hidden" name="NEW_ITEM-DESCRIPTION[' + nb + ']" value="' + result.name + ' 19%">';
                productInputs += '<input type="hidden" name="NEW_ITEM-QUANTITY[' + nb + ']" value="' + this.$store.getters.getSelectedQty + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-UNIT[' + nb + ']" value="H87">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICE[' + nb + ']" value="' + priceSplitted.tax19 + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CURRENCY[' + nb + ']" value="EUR">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICEUNIT[' + nb + ']" value="1">';
                productInputs += '<input type="hidden" name="NEW_ITEM-LEADTIME[' + nb + ']" value="' + this.$store.getters.getSelectedItem.getDeliveryTime(this.$store) + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-VENDORMAT[' + nb + ']" value="' + result.id + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-MATGROUP[' + nb + ']" value="Gift">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD1[' + nb + ']" value="19">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD5[' + nb + ']" value="' + response.data.orderId + '">';
                ++nb;
              }

              this.$store.getters.getSelectedItem.data.products.forEach(p => {
                productInputs += '<input type="hidden" name="NEW_ITEM-DESCRIPTION[' + nb + ']" value="' + p.name + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-QUANTITY[' + nb + ']" value="' + this.$store.getters.getSelectedQty + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-UNIT[' + nb + ']" value="H87">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICE[' + nb + ']" value="' + (this.getPriceLevel3ForGroup(p, this.$store.getters.getUserGroupId, false).replace('€', '').replace(' ', '').replace('.', '').replace(',', '.') / (1 + (p.tax / 100))).toFixed(10) + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CURRENCY[' + nb + ']" value="EUR">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICEUNIT[' + nb + ']" value="1">';
                productInputs += '<input type="hidden" name="NEW_ITEM-LEADTIME[' + nb + ']" value="' + this.$store.getters.getSelectedItem.getDeliveryTime(this.$store) + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-VENDORMAT[' + nb + ']" value="' + p.id + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-MATGROUP[' + nb + ']" value="Gift">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD1[' + nb + ']" value="' + p.tax + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD5[' + nb + ']" value="' + response.data.orderId + '">';
                ++nb;
              });

              priceSplitted = this.splittedTaxSingleRawSum(this.composerPrices.filter(e => e.key.startsWith('shipping')).map(e => e.multPriceRaw).reduce((e1, e2) => { return e1 + e2; }, 0) / this.boxQty);
              if (priceSplitted.tax7 > 0) {
                productInputs += '<input type="hidden" name="NEW_ITEM-DESCRIPTION[' + nb + ']" value="Versand 7%">';
                productInputs += '<input type="hidden" name="NEW_ITEM-QUANTITY[' + nb + ']" value="' + this.$store.getters.getSelectedQty + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-UNIT[' + nb + ']" value="H87">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICE[' + nb + ']" value="' + priceSplitted.tax7 + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CURRENCY[' + nb + ']" value="EUR">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICEUNIT[' + nb + ']" value="1">';
                productInputs += '<input type="hidden" name="NEW_ITEM-LEADTIME[' + nb + ']" value="' + this.$store.getters.getSelectedItem.getDeliveryTime(this.$store) + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-VENDORMAT[' + nb + ']" value="0">';
                productInputs += '<input type="hidden" name="NEW_ITEM-MATGROUP[' + nb + ']" value="Shipping">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD1[' + nb + ']" value="7">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD5[' + nb + ']" value="' + response.data.orderId + '">';
                ++nb;
              }
              if (priceSplitted.tax19 > 0) {
                productInputs += '<input type="hidden" name="NEW_ITEM-DESCRIPTION[' + nb + ']" value="Versand 19%">';
                productInputs += '<input type="hidden" name="NEW_ITEM-QUANTITY[' + nb + ']" value="' + this.$store.getters.getSelectedQty + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-UNIT[' + nb + ']" value="H87">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICE[' + nb + ']" value="' + priceSplitted.tax19 + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CURRENCY[' + nb + ']" value="EUR">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICEUNIT[' + nb + ']" value="1">';
                productInputs += '<input type="hidden" name="NEW_ITEM-LEADTIME[' + nb + ']" value="' + this.$store.getters.getSelectedItem.getDeliveryTime(this.$store) + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-VENDORMAT[' + nb + ']" value="0">';
                productInputs += '<input type="hidden" name="NEW_ITEM-MATGROUP[' + nb + ']" value="Shipping">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD1[' + nb + ']" value="19">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD5[' + nb + ']" value="' + response.data.orderId + '">';
                ++nb;
              }

              if (this.$store.getters.getComposerModules.postcard.main.mode === 1) {
                productInputs += '<input type="hidden" name="NEW_ITEM-DESCRIPTION[' + nb + ']" value="Grußkarte ' + this.$store.getters.getPostcards.filter(p => p.id === this.$store.getters.getSelectedPostcard.id)[0].name.substr(0, 30) + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-LONGTEXT_' + nb + ':132" value="' + this.$store.getters.getComposerModules.postcard.message.text + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-QUANTITY[' + nb + ']" value="' + this.$store.getters.getSelectedQty + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-UNIT[' + nb + ']" value="H87">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICE[' + nb + ']" value="0.01">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CURRENCY[' + nb + ']" value="EUR">';
                productInputs += '<input type="hidden" name="NEW_ITEM-PRICEUNIT[' + nb + ']" value="1">';
                productInputs += '<input type="hidden" name="NEW_ITEM-LEADTIME[' + nb + ']" value="' + this.$store.getters.getSelectedItem.getDeliveryTime(this.$store) + '">';
                productInputs += '<input type="hidden" name="NEW_ITEM-VENDORMAT[' + nb + ']" value="0">';
                productInputs += '<input type="hidden" name="NEW_ITEM-MATGROUP[' + nb + ']" value="Card">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD1[' + nb + ']" value="7">';
                productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD5[' + nb + ']" value="' + response.data.orderId + '">';
                ++nb;
              }

              if (this.composerPrices.filter(e => e.key.startsWith('postcard')).length > 0) {
                priceSplitted = this.splittedTaxSingleRawSum(this.composerPrices.filter(e => e.key.startsWith('postcard')).map(e => e.singlePriceRaw).reduce((e1, e2) => { return e1 + e2; }, 0));
                if (priceSplitted.tax7 > 0) {
                  productInputs += '<input type="hidden" name="NEW_ITEM-DESCRIPTION[' + nb + ']" value="Grußkartenextras 7%">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-QUANTITY[' + nb + ']" value="' + this.$store.getters.getSelectedQty + '">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-UNIT[' + nb + ']" value="H87">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-PRICE[' + nb + ']" value="' + priceSplitted.tax7 + '">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-CURRENCY[' + nb + ']" value="EUR">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-PRICEUNIT[' + nb + ']" value="1">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-LEADTIME[' + nb + ']" value="' + this.$store.getters.getSelectedItem.getDeliveryTime(this.$store) + '">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-VENDORMAT[' + nb + ']" value="0">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-MATGROUP[' + nb + ']" value="Extra">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD1[' + nb + ']" value="7">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD5[' + nb + ']" value="' + response.data.orderId + '">';
                  ++nb;
                }
                if (priceSplitted.tax19 > 0) {
                  productInputs += '<input type="hidden" name="NEW_ITEM-DESCRIPTION[' + nb + ']" value="Grußkartenextras 19%">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-QUANTITY[' + nb + ']" value="' + this.$store.getters.getSelectedQty + '">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-UNIT[' + nb + ']" value="H87">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-PRICE[' + nb + ']" value="' + priceSplitted.tax19 + '">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-CURRENCY[' + nb + ']" value="EUR">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-PRICEUNIT[' + nb + ']" value="1">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-LEADTIME[' + nb + ']" value="' + this.$store.getters.getSelectedItem.getDeliveryTime(this.$store) + '">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-VENDORMAT[' + nb + ']" value="0">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-MATGROUP[' + nb + ']" value="Extra">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD1[' + nb + ']" value="19">';
                  productInputs += '<input type="hidden" name="NEW_ITEM-CUST_FIELD5[' + nb + ']" value="' + response.data.orderId + '">';
                  ++nb;
                }
              }
              const formStr =
                '<form method="post" action="' +
                this.$store.getters.getArag.data.HOOK_URL +
                '" id="formToSubmit">' + hiddenInputs + productInputs + '</form>"';
              const div = document.createElement('div');
              div.innerHTML = formStr;
              document.body.appendChild(div);
              document.getElementById('formToSubmit').submit();
            } else if (response.status === 200 && 'url' in response.data) {
              localStorage.removeItem('lastSelectedItemLevel3');
              localStorage.removeItem('lastSelectedQty');
              localStorage.removeItem('lastSelectedPostcard');
              sessionStorage.removeItem('composerItem');
              this.$store.commit('setSelectedItem', null);
              if (redirect) {
                window.location.href = response.data.url;
              } else {
                localStorage.removeItem('lastSelectedItemLevel3');
                localStorage.removeItem('lastSelectedQty');
                localStorage.removeItem('lastSelectedPostcard');
                sessionStorage.removeItem('composerItem');
                this.$store.commit('setSelectedItem', null);
                this.updateAfterLevel3();
                this.$store.commit('setGlobalLoading', false);
                this.$router.push(this.cLink('/'));
              }
            } else if (response.status === 200 && 'content' in response.data) {
              const formStr =
                '<form method="post" action="' +
                response.data.checkout_url +
                '" id="formToSubmit"><input type="hidden" name="cXML-urlencoded" value=\'' +
                response.data.content +
                "'></form>";
              const div = document.createElement('div');
              div.innerHTML = formStr;
              document.body.appendChild(div);
              document.getElementById('formToSubmit').submit();
            } else if (response.status === 200 && 'custom_error' in response.data && response.data.custom_error === 'no_stock') {
              this.showErrorStock = true;
              this.$store.commit('setGlobalLoading', false);
              this.clickedAddedToCart = false;
            } else {
              this.showError = true;
              this.$store.commit('setGlobalLoading', false);
              this.clickedAddedToCart = false;
            }
          })
          .catch((_) => {
            this.showError = true;
            this.$store.commit('setGlobalLoading', false);
            this.clickedAddedToCart = false;
          });
      }
    },
    displayDateFromDesired(date) {
      const d = new Date(date);
      const day = d.getDay();
      var display = '';
      switch (day) {
        case 0: display = 'Sonntag'; break;
        case 1: display = 'Montag'; break;
        case 2: display = 'Dienstag'; break;
        case 3: display = 'Mittwoch'; break;
        case 4: display = 'Donnerstag'; break;
        case 5: display = 'Freitag'; break;
        case 6: display = 'Samstag'; break;
      }
      return `${display} ${('0' + d.getDate()).slice(-2)}.${('0' + (d.getMonth() + 1)).slice(-2)}`;
    },

    goBack (hash) {
      hash = hash || '';

      if (sessionStorage.getItem('confirmationPageReferrer')) {
        this.$router.push(this.cLink(sessionStorage.getItem('confirmationPageReferrer')) + hash);
      } else {
        if (this.$store.getters.getSelectedItem.data.type === 'level_1') {
          this.$router.push(this.cLink('/fertige') + hash);
        } else {
          this.$router.push(this.cLink('/zusammenstellen') + hash);
        }
      }
    }
  },
  computed: {
    displayDate: function() {
      const d = new Date();
      const day = d.getDay();
      var display = '';
      switch (day) {
        case 0: display = 'Sonntag'; break;
        case 1: display = 'Montag'; break;
        case 2: display = 'Dienstag'; break;
        case 3: display = 'Mittwoch'; break;
        case 4: display = 'Donnerstag'; break;
        case 5: display = 'Freitag'; break;
        case 6: display = 'Samstag'; break;
      }
      return `${display} ${('0' + d.getDate()).slice(-2)}.${('0' + (d.getMonth() + 1)).slice(-2)}`;
    },

    getLevel1Items() {
      const ret = [];
      this.$store.getters.getSelectedItem.includedProducts().forEach(item => {
        if (item.replaced) {
          item = { ...item.replaceData, quantity: item.quantity };
        }
        for (var i = 0; i < item.quantity; i++) {
          ret.push({
            ...item
          });
        }
      });

      return ret;
    }
  },
  watch: {
    $route(to, from) {
      if (
        this.$route.name === 'ConfirmModalProduct'
      ) {
        if (this.$store.getters.getSelectedItem.data.type === 'level_1') {
          this.$store.getters.getListItemsLevel3All.forEach(
            (product) => {
              if (product.id === parseInt(this.$route.params.product)) {
                this.$store.commit('setModalItem', product);
              }
            }
          );
        } else if (
          this.$store.getters.getSelectedItem.data.type === 'level_3'
        ) {
          this.$store.getters.getSelectedItem.data.products.forEach(
            (product) => {
              if (product.id === parseInt(this.$route.params.product)) {
                this.$store.commit('setModalItem', product);
              }
            }
          );
        }
        this.$store.commit('setModalOpen', true);
      } else {
        this.$store.commit('setModalOpen', false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * PresentConfirmation
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Present confirmation page before adding it to the cart or continue to create another one. Kind of a middle screen.
 * @since 2021-09-13
**/

$component: 'confirmation';

.#{$component} {
  @include padding(map-get($spacers, 4) 0);
  background-color: $sky-light;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__wrapper {
    max-width: 640px;
    margin: 0 auto;
    @include padding(map-get($spacers, 4) auto);
  }

  &__logo {
    @include margin(0 0 map-get($spacers, 5) 0);
    text-align: center;

    img {
      width: auto;
      @include rfs(3rem, height);
    }
  }

  &__content {
    position: relative;
    max-width: 700px;
    margin: 0 auto;
    @include padding(map-get($spacers, 4) map-get($spacers, 4));
    border-radius: $border-radius-lg;
    background-color: $white;
    box-shadow: 0 0 0 1px rgba(63, 63, 68, 0.05),
              0 1px 3px 0 rgba(63, 63, 68, 0.15);
  }

  &__alert {
    margin: 0;
    @include margin-bottom(map-get($spacers, 3));
  }

  &__module {
    display: block;
    width: 100%;

    & + & {
      @include margin-top(map-get($spacers, 4));
      @include padding-top(map-get($spacers, 4));
      border-top: 1px solid $gray-ghost;
    }
  }

  &__module-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @include margin-bottom(map-get($spacers, 4));
  }

  &__module-info {
    display: flex;
    align-items: center;
  }

  &__module-actions {

  }

  &__module-icon {
    @include rfs(5rem, width);
    @include margin-right(map-get($spacers, 3));

    img {
      display: block;
      width: 100%;
    }
  }

  &__module-text {
  }

  &__module-name {
    margin: 0;
  }

  &__module-description {
    @include margin(map-get($spacers, 1) 0 0 0);
    color: $ink-lighter;
  }

  &__module-content {
  }

  // Products
  &__products {
    @include unlist;
  }

  &__product {
    display: flex;
    align-items: flex-start;
    flex-wrap: nowrap;
    width: 100%;

    > a {
      display: flex;
      align-items: flex-start;
      flex-wrap: nowrap;
      width: 100%;
      color: $ink;
    }

    &:not(:last-child) {
      @include margin-bottom(map-get($spacers, 1) * 2.8);
    }
  }

  $photo-width: 46px;
  $photo-margin: 10px;

  &__product-photo {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 2.8rem;
    aspect-ratio: 1 / 1;
    @include margin-right(map-get($spacers, 2));
    @include padding(0.1rem);
    border: 1px solid $gray-ghost;
    border-radius: $border-radius-sm;
    background-color: $white;

    img {
      display: block;
      width: 100%;
      aspect-ratio: 1 / 1;
    }
  }

  &__product-info {
    display: flex;
    min-width: 0;
    flex-direction: column;
    flex-grow: 1;
    flex-shrink: 1;
    margin: 0;
  }

  &__product-name {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &__product-description {
    width: 100%;
    overflow: hidden;
    margin-top: -2px;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: $ink-lighter;
  }

  &__product-price {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-shrink: 0;
    @include font-size($font-size-sm);
    text-align: right;

    small {
      font-weight: $font-weight-light;
    }
  }

  &__product-price-line1 {
    font-weight: $font-weight-bold;
  }

  &__product-price-line2 {
    color: $ink-lightest;
  }

  &__selected-options {
    @include unlist;
    columns: 2;

    > li {
      display: inline-block;
      width: 100%;
      break-inside: avoid;
      position: relative;
      @include padding-left($font-size-base * 1.2 + map-get($spacers, 1));

      &:before {
        content: '\e913';
        position: absolute;
        left: 0;
        color: $primary;
        @include font-size($font-size-base * 1.2);
        font-family: icomoon;
      }

      > img {
        @include rfs(1rem, width);
        height: auto;
        vertical-align: middle;
      }
    }
  }

  &__postcard-motive {
    border: 1px solid $gray-ghost;
  }

  &__postcard-message {
    font-style: italic;
    &:before {
    }
  }

  &__footer {
    position: sticky;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    @include margin(0 (- map-get($spacers, 4)) (- map-get($spacers, 4)));
    @include padding(map-get($spacers, 4));
    // border-top: 1px solid $sky;
    border-bottom-left-radius: $border-radius-lg;
    border-bottom-right-radius: $border-radius-lg;
    background-color: $sky-light;

    > div {
      flex: 48% 0 0;
    }
  }

  &__button {
    width: 100%;

    & + & {
      // margin: 0;
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {

  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    padding-bottom: 0;

    &__header {
      @include padding(0 map-get($spacers, 4));
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    &__footer {
      flex-direction: column-reverse;

      > div:first-child {
        @include margin-top(map-get($spacers, 2));
      }
    }
  }
}
</style>
